import React from "react";
import { useNavigate } from "react-router-dom";
import "./Stone.css";
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const Maintenance = () => {
  const navigate = useNavigate();

  const goToQuoteForm = () => {
    sessionStorage.setItem("scrollToQuote", "true");
    navigate("/");
  };

  return (
    <div className="stone-page">
      <Header />
      {/* Hero Section */}
      <section className="stone-hero">
        <h1>Professional Maintenance Services</h1>
        <p>
          Keep your outdoor space clean, healthy, and thriving all year long. We handle the hard work so you don’t have to.
        </p>
      </section>

      {/* Services Highlights */}
      <section className="stone-services">
        <div className="stone-card-grid">
          {[
            {
              title: "Lawn Mowing & Edging",
              description: "Routine care that keeps your lawn looking sharp and well-groomed.",
            },
            {
              title: "Weed & Pest Control",
              description: "Protect your landscape from invasive species and unwanted pests.",
            },
            {
              title: "Seasonal Cleanup",
              description: "Leaf removal, pruning, and preparation for spring or fall transitions.",
            },
            {
              title: "Ongoing Maintenance Plans",
              description: "Custom schedules to keep your landscape in peak condition.",
            },
          ].map((item, i) => (
            <div className="stone-card" key={i}>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Image Grid */}
      <section className="stone-gallery">
        {["maintenance.jpg", "maintenance1.jpg", "maintenance2.jpg"].map((img, i) => (
          <img
            key={i}
            src={`/images/${img}`}
            alt={`Maintenance project ${i + 1}`}
          />
        ))}
      </section>

      {/* CTA Section */}
      <section className="stone-cta">
        <p>
          Ready for reliable, professional landscape maintenance? Let’s keep your yard looking its best.
        </p>
        <button
          className="cta-btn"
          onClick={goToQuoteForm}
          style={{
            backgroundColor: "#2E7D32",
            color: "white",
            border: "none",
            padding: "12px 30px",
            fontSize: "1rem",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          Request an Estimate <span className="cta-arrow">→</span>
        </button>
      </section>
      <Footer />
    </div>
  );
};

export default Maintenance;
